export function getMeetsLink() {
    return '/meets'
}
